module.exports = __webpack_public_path__ + "static/media/Brand-Forum-Press_9.8in-X-14in.ab67c4f2.jpg";